/**
 * Puts a vendored card's CSS into `<head>` once, by id, so it applies wherever
 * the card renders. The cards ship their CSS as a React 19 hoisted `<style
 * href precedence>`, which React dedupes by href per root: a card first drawn
 * inside Tiptap's suggestion renderer keeps its style inline in that element,
 * and once that element is removed, a later card in the app's own tree (the
 * chip pop-up over the composer) renders with no styles at all. A plain
 * `<style>` appended here sits after the app's stylesheets, so the card's own
 * rules also stop losing ties to Tailwind's and Chakra's. Called on render:
 * the id check keeps it to one element, and puts it back if the head was
 * cleared (as Cypress does between component tests).
 */
export function ensureStyle(id: string, css: string) {
  if (typeof document === 'undefined' || document.getElementById(id)) return;
  const style = document.createElement('style');
  style.id = id;
  style.textContent = css;
  document.head.appendChild(style);
}
